import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { hosClockViolationRefs } from "../subjects/hosClockViolation/refs";

/**
 * The clocks a violation may be reported against, in hours, as the vendor labels them.
 *
 * A closed union rather than a number because a clock is a member of the ruleset's vocabulary and not a quantity: an
 * hours figure outside this set names a clock the subject has not mapped, which a normalizer reports as unmapped
 * rather than writes as a fact. Declared with the first of the four kinds and shared by the rest, so one vocabulary
 * governs the subject and a clock added to it reaches every kind at once.
 */
export const HosClockHoursSchema = z
  .union([z.literal(8), z.literal(11), z.literal(14), z.literal(70)])
  .openapi("HosClockHours");

export type HosClockHours = z.infer<typeof HosClockHoursSchema>;

/**
 * The driver's break clock ran out.
 */
export const breakOverdueV1 = tmsEventKind(
  { category: "hoursOfService", kind: "breakOverdue", version: 1 },
  {
    refs: hosClockViolationRefs,
    facts: {
      /** The clock's length in hours, as the vendor labels it. */
      clockHours: HosClockHoursSchema,
    },
  },
);

export const BreakOverdueV1Schema = breakOverdueV1.schema;
export const BreakOverdueV1FactsSchema = breakOverdueV1.facts;

export type BreakOverdueV1 = z.infer<typeof BreakOverdueV1Schema>;
export type BreakOverdueV1Facts = z.infer<typeof BreakOverdueV1FactsSchema>;

/** Every version of `breakOverdue`, keyed by version. What `catalog.ts` places under `hoursOfService`. */
export const breakOverdue = { 1: breakOverdueV1 } as const;
